import { CookieService } from './../../../../shared/services/cookie/cookie.service';
import { SignupService } from '../../../../shared/services/signup/signup.service';
import { Subscription } from 'rxjs';
import { HomepageService } from './../../../../homepage/services/homepage.service';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IGTM, ISystemEvent } from '../../../../shared/models/events.model';
import { CampaignService, EventsService, StorageService, UtilService, VariablesService } from '../../../../shared/services';
import { RecaptchaComponent } from 'ng-recaptcha';
import { FORM_TEXTS } from '../../../../../app/campaign/components/objects/placeholder';
import { RELATIONSHIP } from '../../../../medical-campaign/objects/relationship';
interface LoginResponse {
  response: any;
  statts: string;
}

@Component({
  selector: 'app-start-fundraiser-widget',
  templateUrl: './start-fundraiser-widget.component.html',
  styleUrls: ['./start-fundraiser-widget.component.scss'],
})
export class StartFundraiserWidgetComponent implements OnInit, OnDestroy {

  public basicForm: FormGroup;
  public amount_requested: FormControl;
  public relation: FormControl;
  public beneficiaryPhone: FormControl;
  public captcha: FormControl;
  public name: FormControl;
  showCaptcha = true;
  public info = FORM_TEXTS.English;
  public relationship = RELATIONSHIP;
  @Input() public draft;
  @Input() public causes: any[];
  @ViewChild('captchaRef') public captchaRef: RecaptchaComponent;
  @ViewChild('benificiary') public benificiary;
  @Input() isLoading;
  public beneficiaryRel;
  public captchaRes;
  public show = {
    beneficiaryname: false,
    ngo: false
  };
  public type;
  public userType;
  public ngoId;
  public hideDock;
  extn;
  userData;
  isLoggedIn;
  leadCreated = false;
  leadSubscription: Subscription;
  loginResponse: LoginResponse;

  constructor(
    public router: Router,
    public actRoute: ActivatedRoute,
    public utilService: UtilService,
    public campaignService: CampaignService,
    public storageService: StorageService,
    public eventsService: EventsService,
    private homepageService: HomepageService,
    @Inject(DOCUMENT) private document: any,
    private signupService: SignupService,
    private cookieService: CookieService,
    public variablesService: VariablesService
  ) {
  }

  ngOnInit() {
    this.initForm();
    this.checkLoggedIn();
    this.utilService.number.subscribe({
      next: (res) => {
        if (res && res.extn) {
          this.extn = res.extn;
        }
      }
    });
    if (this.utilService.isBrowser) {
      document.querySelector('.start-fr-dock .amount-field input').addEventListener('keypress', (evt: any) => {
        if (evt.which !== 8 && evt.which !== 0 && evt.which < 48 || evt.which > 57) {
          evt.preventDefault();
        }
      });
    }
  }

  checkLoggedIn() {
    this.utilService.isLoggedIn.subscribe(
      (data) => {
        this.isLoggedIn = data;
        this.userData = this.storageService.get('userdata');
        if (this.userData && this.basicForm) {
          this.basicForm.patchValue({
            name: this.userData.full_name,
            beneficiaryPhone: this.userData.phone_1
          });
          this.variablesService.draftData.subscribe((res) => {
            if (res) {
              this.hideDock = true;
              this.variablesService.setStartFundraiserWidgetStatus(true);
            }
          });
        }
        if (!data) {
          this.hideDock = data;
          this.variablesService.setStartFundraiserWidgetStatus(true);
        }
      }
    );
  }
  /**
   * Init the form
   */
  initForm() {
    this.basicForm = new FormGroup({
      amount_requested: this.amount_requested = new FormControl('', [Validators.required, Validators.min(2000), Validators.max(50000000)]),
      relation: this.relation = new FormControl('', Validators.required),
      captcha: this.captcha = new FormControl('', []),
      beneficiaryPhone: this.beneficiaryPhone = new FormControl('', [Validators.required]),
      name: this.name = new FormControl('', [Validators.required, Validators.pattern(/[a-z,.'-]{4,}/i)])
    });
    if (this.isLoggedIn) {
      this.userData = this.storageService.get('userdata');
      this.basicForm.patchValue({
        name: this.userData.full_name,
        beneficiaryPhone: this.userData.phone_1
      });
    }
  }
  /**Add control dynamicaly */
  addControl(name: string, control: FormControl) {
    this.basicForm.addControl(name, control);
  }
  /**remove control */
  removeControl(control: string) {
    this.basicForm.removeControl(control);
  }
  public resolved(captchaResponse: string) {
    this.captcha.setValue(captchaResponse);
  }
  /**Submit button click mock */
  submitButton() {
    // this.captchaRef.execute();
    this.document.getElementById('submitBtn1').click();
  }
  /**Submit form */
  basic() {
    if (this.basicForm.valid) {
      const payload: any = {
        'amount_requested': this.amount_requested.value,
        'cause_id': 59, // this.cause_id.value,
        'parent_cause_id': 20, // this.parentCauseId,
        'g-recaptcha-response': this.captcha.value
      };
      if (this.relation.value !== 'Self') {
        payload.beneficiaryrelation = {
          'info_type': 'beneficiary_relation',
          'entity_type': 'campaign',
          'info_1': this.relation.value
        };
      }
      const date = new Date();
      payload.title = `Draft fundraiser created on ${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
      this.checkWhichServiceToCall(payload);
    } else {
      this.utilService.checkValidForm(this.basicForm);
      this.isLoading = false;
    }
  }

  checkWhichServiceToCall(payload) {
    const payload1 = {
      eventName: 'start_a_campaign_initiated',
      event_type: 'campaign',
      page_name: this.variablesService.pageName,
      referrer_page: this.document.referrer,
      info_1: 'type',
      info_2: 'dock',
      event_type_id: ''
    };
    this.eventsService.systemEventPush(payload1);
    this.storageService.checkFromSession('sac-initiated', payload1);
    if (this.isLoggedIn) {
      this.isLoading = true;
      this.createCampaign(payload); /** Create draft fundraiser and redirect to respective page */
    } else {
      this.generateLead();
      const campaignerData = {
        'mobile': this.beneficiaryPhone.value,
        'extension': this.extn,
        'name': this.name.value
      };
      this.storageService.addSessionData('dockFrData', payload);
      this.storageService.addSessionData('dockCampaignerData', campaignerData);
      this.signupService.startFrType = 'medical';
      this.router.navigate(['new/crowdfunding'], { queryParams: { type: 'medical' }, queryParamsHandling: 'merge' });
    }
  }
  /** Generate lead api call */
  generateLead() {
    const ku = this.cookieService.getCookie('_ku');
    const payload = {
      about: `Amount: ₹${this.amount_requested.value}`,
      email: `${ku}@ketto.org`,
      name: this.name.value || 'lead',
      page: this.variablesService.pageName,
      phone: this.beneficiaryPhone.value.replace(/\s/g, ''),
      extension: this.extn,
      query_type: 'want_to_raise_funds',
      type: 'P - Homepage Dock',
      cause: 'medical',
      mail_to: this.variablesService.leadMailTo,
      subject: 'Bottom dock - ' + this.variablesService.leadSubject,
      city: this.utilService.getCityFromIp()
    };
    Object.assign(payload, this.utilService.getUTMs());
    this.leadSubscription = this.homepageService.postLeadData(payload, true).subscribe(
      (res: any) => {
        if (res.error === false) {
          const pageViewPayload = {
            eventName: 'campaign_lead_created',
            event_type: 'campaign',
            info_2: res.data.id,
            page_name: 'dock',
            referrer_page: this.utilService.getReferrer()
          };
          this.eventsService.sendSystemEvent(pageViewPayload).subscribe();
        }
        this.signupService.isLeadGenerated = true;
        this.leadCreated = true;
      },
      err => {
        console.log(err);
      }
    );
  }
  /**Create campaign
   * @param payload required data for creating campaign
   */
  createCampaign(payload, userData?) {
    this.campaignService.createCampaign(payload).subscribe((res: any) => {
      // this.getDraftById(res.data.creator_entity_details_id, res.data.id, this.type);
      this.gtmPush(res.data);
      this.sendSystemEvent(res.data);
      if (this.captchaRef) {
        this.captchaRef.reset();
      }
      this.showCaptcha = false;
      this.utilService.nativeNavigation(`${this.variablesService.startAFrUrls.medical}/advance?did=${res.data.id}`);
    });
  }
  /**
   * ALL THE EVENT TRACKING FUNCTIONS
   */
  sendSystemEvent(data) {
    const sacPuposeSelected = this.storageService.getFromSession('sac-purpose-selected');
    if (!sacPuposeSelected) {
      const payload2 = {
        eventName: 'cause_selection',
        event_type: 'campaign',
        page_name: this.variablesService.pageName,
        event_type_id: '',
        info_1: 'type',
        info_2: 'dock',
        info_4: 'medical',
      };
      this.eventsService.systemEventPush(payload2);
      this.storageService.addSessionData('sac-purpose-selected', { 'purpose': 'medical' });
    }
    const payload3: ISystemEvent = {
      eventName: 'start_a_campaign_step1_completed',
      event_type: 'campaign',
      page_name: 'Start a Campaign step1',
      info_1: 'type',
      info_2: this.utilService.getCampaignTypeFromId(data.parent_cause_id),
      info_3: this.storageService.get('language') || 'English',
      event_type_id: data.id || ''
    };
    this.eventsService.systemEventPush(payload3);
  }
  /**GTM data push */
  gtmPush(data) {
    const dataPush: IGTM = {
      event: 'fundraiser_',
      eventCategory: 'fundraiser',
      eventAction: data.parent_cause_name,
      eventLabel: 'step1_completed',
      Campaign_cause_id: data.cause_id,
      Campaign_id: Number(data.draftid),
      Campaign_Type: data.parent_cause_name
    };
    this.eventsService.gtmPush(dataPush);
  }
  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    if (this.leadCreated) {
      this.leadSubscription.unsubscribe();
    }
  }

}
